import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getSpecialGameModePaths } from "lib/specialGameMode";
import MediaQuery from "components/MediaQuery";
import PageNav from "components/PageNav";
import { useActiveSpecialModes } from "lib/hooks/specialModeHooks";
import { useGlobal } from "reactn";
import { useParams } from "react-router-dom";

const ChampionPageNav = (props) => {
  const { t } = useTranslation();
  const { championKey } = props;
  const [language] = useGlobal("language");
  const params = useParams();

  let normalizedChampionName = championKey.toLowerCase();
  if (normalizedChampionName === "monkeyking") {
    normalizedChampionName = "wukong";
  }

  let rootPathname = `/lol/champions/${normalizedChampionName}`;
  let languageBuildPathname =
    language !== "en_US"
      ? `/lol/${language.toLowerCase()}/champions/${normalizedChampionName}`
      : `/lol/champions/${normalizedChampionName}`;
  let multiBuildPathname = `/lol/champions/${params.multi}/${normalizedChampionName}`;

  const liveSpecialModes = useActiveSpecialModes();

  // Temporary fix to remove urf from the liveSpecialModes
  //
  // if (liveSpecialModes.includes("urf")) {
  //   const index = liveSpecialModes.indexOf("urf")
  //   if (index > -1) {
  //     liveSpecialModes.splice(index, 1)
  //   }
  // }

  const specialGameModePaths = [];
  const paths = getSpecialGameModePaths(normalizedChampionName, liveSpecialModes);

  for (let i = 0; i < paths.length; i++) {
    paths[i].label = t(paths[i].label);
    //Depending how we add builds in the future, this is only ap for now
    //We could add each one ourselfs or use the multi param that's here
    const URL = paths[i].activePaths[0];
    const CHAMP_INDEX = paths[i].activePaths[0].indexOf(normalizedChampionName);
    paths[i].activePaths.push(URL.slice(0, CHAMP_INDEX) + "ap/" + URL.slice(CHAMP_INDEX));

    specialGameModePaths.push(paths[i]);
  }

  const tabs = [
    {
      path: `${languageBuildPathname}/build`,
      label: t("Build"),
      activePaths: [`${languageBuildPathname}/build`, new RegExp(`${rootPathname}\/.+-build`), `${multiBuildPathname}`],
    },
    { path: `${rootPathname}/runes`, label: t("Runes") },
    ...specialGameModePaths,
    { path: `${rootPathname}/counter`, label: t("Counters") },
    // {path: `${rootPathname}/probuilds`, label: t("Pro Builds"), reset: true},
    {
      path: `/lol/champion-leaderboards/${normalizedChampionName}`,
      label: t("Leaderboards"),
      // queryParams: `?champion=${normalizedChampionName}`,
      new: true,
    },
    {
      customComponent: (
        <a
          className="pbs-tab"
          target="_blank"
          href={`https://probuildstats.com/champion/${normalizedChampionName}`}
          rel="noreferrer"
        >
          <img
            className="pbs-logo"
            src="https://static.bigbrain.gg/assets/probuildstats/logos/pbs-logo.svg"
            alt="ProbuildStats"
          />
          {t("Pro Builds")}
        </a>
      ),
    },
    {
      label: t("More Stats"),
      // new: true,
      dropdown: [
        {
          customComponent: (
            <a
              className="og-tab"
              target="_blank"
              href={`https://onlyguides.com/lol/${normalizedChampionName}/guide`}
              rel="noreferrer"
            >
              <div style={{ marginRight: "5px", display: "inline-block" }}>
                <svg alt="onlyguides" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="5 0 35 35">
                  <g>
                    <g>
                      <g>
                        <path
                          fill="#fff"
                          d="M16 32.648c-3.173 0-5.603-.813-7.27-2.44-1.666-1.626-2.5-4.156-2.5-7.592 0-3.616.834-6.251 2.5-7.837C10.398 13.193 12.828 12.4 16 12.4c3.21 0 5.64.793 7.307 2.379 1.693 1.586 2.5 4.221 2.5 7.837 0 3.436-.807 5.966-2.5 7.593-1.668 1.626-4.097 2.44-7.307 2.44m0-4.179c1.665 0 2.87-.47 3.632-1.418.763-.945 1.144-2.424 1.144-4.436 0-2.196-.381-3.746-1.144-4.616-.762-.94-1.967-1.392-3.632-1.392-1.648 0-2.863.453-3.625 1.392-.763.87-1.144 2.42-1.144 4.616 0 2.012.381 3.491 1.144 4.436.762.948 1.977 1.418 3.625 1.418"
                        />
                      </g>
                      <g>
                        <path
                          fill="#fff"
                          d="M30.414 24.222h4.238v3.72c-1.016.326-2.114.488-3.293.488-1.79 0-3.14-.43-4.056-1.43-.915-.882-1.372-2.31-1.372-4.241 0-2.115.483-3.675 1.449-4.681.965-1.007 2.505-1.51 4.62-1.51 1 0 2 .061 2.912.183.149.02.296.046.443.07l2.24-3.62a16.933 16.933 0 0 0-2.714-.627 22.457 22.457 0 0 0-3.248-.214c-3.517 0-6.18.915-7.99 2.745-1.809 1.83-2.713 4.38-2.713 7.654 0 3.13.884 5.555 2.653 7.241 1.769 1.75 4.35 2.608 7.746 2.608 1.809 0 3.328-.178 4.558-.533 1.23-.356 2.19-.758 2.882-1.205v-9.727h-6.45z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              {t("OnlyGuides")}
            </a>
          ),
          // new: true,
        },
        { path: `${rootPathname}/matchups`, label: t("Matchups") },
        { path: `${rootPathname}/items`, label: t("Items") },
        { path: `${rootPathname}/item-paths`, label: t("Build Paths") },
        { path: `${rootPathname}/runes-table`, label: t("Runes Table") },
        { path: `${rootPathname}/rune-sets`, label: t("Rune Sets") },
        {
          path: `${rootPathname}/spells-abilities`,
          label: t("Spells & Abilities"),
        },
        { path: `${rootPathname}/duos`, label: t("Duos") },
      ],
    },
  ];

  const mobileTabs = [
    { path: `${rootPathname}/build`, label: t("Build") },
    { path: `${rootPathname}/runes`, label: t("Runes") },
    // {path: `${rootPathname}/probuilds`, label: t("Pro Builds"), reset: true},
    { path: `${rootPathname}/counter`, label: t("Counters") },
    {
      path: `/lol/champions-leaderboards`,
      label: t("Leaderboards"),
      queryParams: `?champion=${normalizedChampionName}`,
      new: true,
    },
    {
      customComponent: (
        <a
          className="pbs-tab"
          target="_blank"
          href={`https://probuildstats.com/champion/${normalizedChampionName}`}
          rel="noreferrer"
        >
          <img
            className="pbs-logo"
            src="https://static.bigbrain.gg/assets/probuildstats/logos/pbs-logo.svg"
            alt="ProbuildStats"
          />
          {t("Pro Builds")}
        </a>
      ),
    },
  ];

  return (
    <div className="champion-page-nav">
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
        <PageNav tabs={mobileTabs} />
      </MediaQuery>
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <PageNav tabs={tabs} />
      </MediaQuery>
    </div>
  );
};

export default ChampionPageNav;
